import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

const styles = {
  display: 'inline-block',
  margin: '0 8px',
  fontSize: '11px'
};

const ContractPickerDates = ({ startDate, endDate, plan, showPlan }) => {
  if (startDate && endDate) {
    return (
      <small style={styles}>
        {showPlan && plan} ({moment(startDate).format('YYYY-MM-DD')} /{' '}
        {moment(endDate).format('YYYY-MM-DD')})
      </small>
    );
  }

  return null;
};

ContractPickerDates.propTypes = {
  plan: PropTypes.string,
  showPlan: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string
};

export default ContractPickerDates;
